/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/**
 * Type-guard for TrayRefillSettings
 * @param refills
 */
export function validateTrayRefillSettings(refills: any[]): boolean {
  if (!Array.isArray(refills)) return false;
  return refills.every((refill) => {
    if (!Array.isArray(refill.scoreRange)) return false;
    if (refill.scoreRange.length !== 2) return false;
    if (typeof refill.scoreRange[0] !== 'number') return false;
    if (typeof refill.scoreRange[1] !== 'number') return false;
    if (typeof refill.minFill !== 'number') return false;
    if (typeof refill.maxFill !== 'number') return false;
    if (typeof refill.minColors !== 'number') return false;
    if (typeof refill.maxColors !== 'number') return false;
    return true;
  });
}
